import axios from "axios";

import { routes } from "../../constants";
import { tableTokenConfig } from "./tableTokenConfig";

const resendSeatPass = async (code, position, token = null) => {
  const response = await axios.post(
    routes.resendTableSeatPass(code, position),
    {},
    tableTokenConfig(token)
  );
  return response;
};
export default resendSeatPass;
